import React from "react";
import styles from "./index.module.scss";
import Styles from "./icon.module.scss";
import Image from "next/image";
import PropTypes from "prop-types";
import Link from "next/link";
import { useDeviceType } from "@/hooks/useDeviceType";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, A11y, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const TitleAndImages = ({ titleAndImagesData = {} }) => {
  const { isAbove, width } = useDeviceType(760);
  const {
    mod = "white",
    heading = "",
    images = [],
    showTitle = false,
    showBorder = false,
    isBold = false,
    showIcon = false,
    showMobileSlider = false,
  } = titleAndImagesData || {};

  const boldClass = isBold
    ? '[font-family:"helveticaBold",Helvetica-Light,sans-serif]'
    : '[font-family:"Helvetica-Light,",NotoSansLight,sans-serif]';

  const imageBoxClass = showTitle
    ? "title-and-images-image-full"
    : "title-and-images-image-box";
  const alignClass = showTitle ? "align-items-start" : "align-items-center";
  if (width === null) return null;
  const renderImageCard = (img, index) => (
    <SwiperSlide key={index}>
      <figure className="koh-shopping-item-2promo">
        <div
          className={`mobile-swiper-container my-[20px] mx-[10px] shadow-[0_0_6px_0_#000] w-full 
        ${
          showMobileSlider
            ? "mb-10 aspect-[3/4]"
            : "md:mb-10 aspect-[2/2.5] right-[10px]"
        } relative`}
        >
          {img?.fields?.image?.fields?.externalUrl ? (
            <Link
              href={img?.fields?.image?.fields?.externalUrl}
              rel="noopener noreferrer"
            >
              <Image
                width={0}
                height={0}
                src={img?.fields?.image?.fields?.imageUrl}
                alt={img?.fields?.image?.fields?.altText}
                className="min-w-full h-auto block spect-w-16 object-contain "
              />
            </Link>
          ) : (
            <Image
              width={0}
              height={0}
              src={img?.fields?.image?.fields?.imageUrl}
              alt={img?.fields?.image?.fields?.altText}
              className="min-w-full h-auto block spect-w-16 object-contain "
            />
          )}
          {img?.fields?.title && (
            <div className="title-and-image-imageTitleBox">
              <p className="title-and-image-imageTitle">{img?.fields?.title}</p>
            </div>
          )}
          {img?.fields?.description && (
            <div className="title-and-image-imageDescription">
              <p className="title-and-image-description">
                {renderRichText(img?.fields?.description, locale)}
              </p>
            </div>
          )}
        </div>
      </figure>
    </SwiperSlide>
  );

  return !showIcon ? (
    <div className={styles.TitleandImagewrapper}>
      <div className={`title-and-images-container ${alignClass}`} mod={mod}>
        <div className="title-and-images-header-box">
          <h2 className={`title-and-images-title ${boldClass}`}>{heading}</h2>
        </div>
        {isAbove ? (
          <div className="title-and-images-content desktop-section">
            {images?.map((image, index) => (
              <div className={imageBoxClass} key={index}>
                <figure className="title-and-images-figure">
                  <div>
                    {image?.fields?.image?.fields?.externalUrl ? (
                      <Link
                        href={image?.fields?.image?.fields?.externalUrl}
                        rel="noopener noreferrer"
                      >
                        <Image
                          className="title-and-images-image"
                          src={image?.fields?.image?.fields?.imageUrl}
                          alt={image?.fields?.image?.fields?.altText}
                          fill
                        />
                      </Link>
                    ) : (
                      <Image
                        className="title-and-images-image"
                        src={image?.fields?.image?.fields?.imageUrl}
                        alt={image?.fields?.image?.fields?.altText}
                        fill
                      />
                    )}
                  </div>
                  {image?.fields?.title && (
                    <div className="title-and-image-imageTitleBox">
                      <p className="title-and-image-imageTitle">
                        {image?.fields?.title}
                      </p>
                    </div>
                  )}
                </figure>
                {showBorder && <div className="koh-underline-2promo"></div>}
              </div>
            ))}
          </div>
        ) : (
          <div className="w-full mobile-section">
            {showMobileSlider ? (
              <Swiper
                spaceBetween={20}
                modules={[Pagination, A11y, Autoplay]}
                slidesPerView={1}
                pagination={{ clickable: true }}
                autoplay={{ delay: 4000, disableOnInteraction: false }}
                loop={true}
                className="custom-swiper w-full"
              >
                {images?.map(renderImageCard)}
              </Swiper>
            ) : (
              images?.map(renderImageCard)
            )}
            {showBorder && <div className="koh-underline-2promo"></div>}
          </div>
        )}
      </div>
    </div>
  ) : (
    <div className={Styles.container}>
      <div className={Styles.title}>
        <h2 className={`${boldClass} ${Styles.titleimages}`}>{heading}</h2>
      </div>
      <div className={Styles.grid}>
        {images.map(item =>
          item?.fields?.image?.fields?.externalUrl ? (
            <Link
              href={item?.fields?.image?.fields?.externalUrl}
              key={item.id}
              className={`h-full ${Styles.divwidth}`}
            >
              <div className={`${Styles.card} cursor-pointer`}>
                <div className={Styles.imageWrapper}>
                  <Image
                    src={item?.fields?.image?.fields?.imageUrl}
                    alt={item?.fields?.title}
                    fill
                    className={Styles.image}
                  />
                </div>

                <div className={Styles.footer}>
                  <h3 className={`${Styles.title} cursor-pointer`}>
                    {item?.fields?.title}
                  </h3>
                  <img
                    className={Styles.icon}
                    src={
                      "https://s7d4.scene7.com/is/image/kohlerchina/360_degree_icon?scl=1"
                    }
                    alt="360°"
                  />
                </div>
              </div>
            </Link>
          ) : (
            <div key={item.id}>
              <div className={`${Styles.card}`}>
                <div className={Styles.imageWrapper}>
                  <Image
                    src={item?.fields?.image?.fields?.imageUrl}
                    alt={item?.fields?.title}
                    fill
                    className={Styles.image}
                  />
                </div>

                <div className={Styles.footer}>
                  <h3 className={Styles.title}>{item?.fields?.title}</h3>
                  <img
                    className={Styles.icon}
                    src={
                      "https://s7d4.scene7.com/is/image/kohlerchina/360_degree_icon?scl=1"
                    }
                    alt="360°"
                  />
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

TitleAndImages.propTypes = {
  titleAndImagesData: PropTypes.object,
};

TitleAndImages.defaultProps = {
  titleAndImagesData: {},
};

export default TitleAndImages;
